import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#53bd91",
    },
    secondary: {
      main: "#0d7d9e",
    },
    text: {
      primary: "#163729",
    },
  },
});

export default theme;
